import { Button } from '@liza/ui/components/ui/button';
import { Spinner } from '@liza/ui/components/ui/spinner';
import { CheckIcon, FolderInputIcon } from 'lucide-react';
import { useCallback } from 'react';

export type PromotionStatus = 'idle' | 'pending' | 'success';

export type RecordPromotionButtonProps = {
  onClick: () => void;
  status?: PromotionStatus;
};

export const RecordPromotionButton = ({ onClick, status = 'idle' }: RecordPromotionButtonProps): React.ReactElement => {
  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>): void => {
      e.preventDefault();
      e.stopPropagation();
      onClick();
    },
    [onClick],
  );

  return (
    <Button variant="ghost" size="icon" onClick={handleClick} disabled={status !== 'idle'} aria-label="Promote record">
      {status === 'pending' ? (
        <Spinner className="size-4 text-muted-foreground" />
      ) : status === 'success' ? (
        <CheckIcon className="size-4 text-green-600" />
      ) : (
        <FolderInputIcon className="size-4 text-muted-foreground" />
      )}
    </Button>
  );
};
